import cacheInMemory from '../utils/cacheInMemory'

export default cacheInMemory.create(true)
